export const programs = [
  { label: "MEP (Mini English Program)" },
  { label: "IEP (Integrated English Program)" },
  { label: "IP (Inter Program)" },
];
